import has from 'lodash/has';
import snakeCase from 'lodash/snakeCase';
import { convertValue } from './inputs';
import {
  isTakeActionResult,
  getPrecision,
} from '../../lib/apiKeys';
import units from '../../lib/units';
import numericInput from '../../lib/numericInput';

export const getNumericResult = (state, key, unitSystem) => {
  const apiOp = isTakeActionResult(key) ? 'compute_takeaction_results' : 'compute_footprint';
  const inputs = state.user_footprint[apiOp];
  if (!has(inputs, key) || !numericInput.isParseable(inputs[key])) {
    throw new Error(`Could not get result for ${key}.`);
  }

  const value = numericInput.parse(inputs[key]);
  const ensuredUnitSystem = unitSystem || state.ui.unitSystem;
  if (!units.isMetric(ensuredUnitSystem)) return value;
  return convertValue(key, value, ensuredUnitSystem, state);
};

/**
 * A selector genererator for a result API key.
 * @param {String} resultProp CamelCase API result key.
 * @param {Boolean} snaked Whether resultProp has already been snakecased.
 * @returns {Function} Will return formatted result.
 */
export default (resultProp, snaked = false) => (state, _ownProps) => {
  const apiKey = snaked ? resultProp : snakeCase(resultProp);
  return numericInput.format(
    getNumericResult(state, apiKey),
    { decimalPlaces: getPrecision(apiKey) },
  );
};
